import { faqCelular, faqCusto, faqProgramar } from './shared'
import type { ProfessionPageConfig } from './types'

export const vendedores: ProfessionPageConfig = {
  path: '/ia-para-vendedores/',
  key: 'vendedores',
  title: 'IA para vendedores e representantes comerciais | Oficina IA',
  description:
    'Três tarefas do dia de vendas que a IA adianta numa pasta: proposta a partir da tabela de preços, quem pediu retorno e o relatório da semana.',
  imageAlt: 'Oficina IA: IA para vendedores',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para vendedores e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para vendedores',
  intro:
    'Proposta, retorno e relatório comem o dia que deveria ser de visita, e a meta não espera. Aqui estão três tarefas dessas que a IA pode ajudar a adiantar, do seu jeito de falar, sem programar.',
  rogerio: { pose: 'animado', text: 'Menos planilha à noite, mais visita de dia.' },
  tasks: [
    {
      title: 'Proposta a partir da tabela',
      tone: 'sky',
      brings: 'a tabela de preços e o que o cliente pediu.',
      helps: 'monta a proposta no seu modelo, com os valores certos.',
      continues: 'confere os números e envia.',
    },
    {
      title: 'Quem pediu retorno e quando',
      tone: 'peach',
      brings: 'as anotações das visitas e das conversas.',
      helps: 'monta a lista do que fazer hoje, por ordem.',
      continues: 'liga, anota o resultado e repete amanhã.',
    },
    {
      title: 'Relatório da semana',
      tone: 'sage',
      brings: 'a planilha de visitas e pedidos.',
      helps: 'escreve o relatório que o gerente pede, com os números.',
      continues: 'lê, ajusta e manda.',
    },
  ],
  steps: {
    do: 'A IA monta a proposta, a lista ou o relatório dentro da sua pasta.',
    check: 'Confira os valores antes de enviar. A IA pode se enganar; o preço é responsabilidade sua.',
    resume: 'Na semana seguinte, troque a planilha e repita o pedido.',
  },
  faq: [
    faqProgramar,
    {
      question: 'A IA vai vender por mim?',
      answer: 'Nas tarefas desta página, quem fala com o cliente é você. A IA prepara a proposta, a lista e o relatório.',
    },
    faqCelular,
    faqCusto,
  ],
  closing: {
    title: 'Sua primeira proposta pronta, com alguém do lado.',
    text: 'Traga a proposta que demora, a lista de retornos ou o relatório da semana.',
    rogerio: 'Eu cuido do novelo. Você cuida do cliente.',
  },
}
